import React from "react";
import { useHistory } from "react-router-dom";
import { IoAdd, IoArrowBack } from "react-icons/io5";
import logo from "../../../assets/images/logo.png";

// Menu button with two bars that cross when the menu is open.
export const Hamburger = ({ open, onClick }) => (
  <button
    type="button"
    className={`hx-ham ${open ? "is-open" : ""}`}
    onClick={onClick}
    aria-label={open ? "Close menu" : "Open menu"}
    aria-expanded={open}
    aria-controls="hx-side-menu"
  >
    <span />
    <span />
  </button>
);

// Back arrow for pages opened from another page. Falls back to the home page
// when the page was opened directly.
export const BackButton = ({ onBack, className = "" }) => {
  const history = useHistory();
  const goBack = () => {
    if (onBack) {
      onBack();
    } else if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/dashboard");
    }
  };
  return (
    <button type="button" className={`hx-icon-btn hx-back ${className}`} onClick={goBack} aria-label="Back">
      <IoArrowBack />
    </button>
  );
};

// Header of the main tabs (app/screens/SideMenuWrapper.js): the purple "+" on
// Home or the tab's title elsewhere, and the menu button. With the menu open
// the "+" becomes the HASHh logo, as in the app.
export const TabHeader = ({ title, menuOpen, onMenu, onAdd }) => (
  <header className="hx-header">
    <div className="hx-header-inner">
      {menuOpen ? (
        <span className="hx-header-logo">
          <img src={logo} alt="HASHh" />
        </span>
      ) : title ? (
        <h1 className="hx-header-title">{title}</h1>
      ) : (
        <button type="button" className="hx-icon-btn hx-header-add" onClick={onAdd} aria-label="Add">
          <IoAdd />
        </button>
      )}
      <Hamburger open={menuOpen} onClick={onMenu} />
    </div>
  </header>
);

// Header of pages opened from another page: back arrow, centred title and an
// optional action on the right.
export const StackHeader = ({ title, onBack, right }) => (
  <header className="hx-header">
    <div className="hx-header-inner">
      <div className="hx-stackbar">
        <BackButton onBack={onBack} />
        <h1 className="hx-stackbar-title">{title}</h1>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>{right}</div>
      </div>
    </div>
  </header>
);
